<template>
    <div>
        <admin-employee-annual-leave-list></admin-employee-annual-leave-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    